import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Composable para obtener y reaccionar a cambios en el tamaño de la ventana
 * Útil para aplicar diseños responsivos basados en el ancho de la pantalla
 */
export function useWindowSize() {
  const width = ref(window.innerWidth)
  const height = ref(window.innerHeight)

  // Se define una función para actualizar las dimensiones
  function updateSize() {
    width.value = window.innerWidth
    height.value = window.innerHeight
  }

  // Se añade el event listener al montar el componente
  onMounted(() => {
    window.addEventListener('resize', updateSize)
  })

  // Se elimina el event listener al desmontar el componente
  onUnmounted(() => {
    window.removeEventListener('resize', updateSize)
  })

  // Helpers para determinar el tipo de dispositivo
  const isMobile = () => width.value < 768
  const isTablet = () => width.value >= 768 && width.value < 1024
  const isDesktop = () => width.value >= 1024

  return {
    width,
    height,
    isMobile,
    isTablet,
    isDesktop
  }
}
